export default {
  API_ENDPOINT: 'https://project-manhattan.herokuapp.com/api',
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY,
  SOCKET_CONNECTION: 'https://project-manhattan.herokuapp.com'
}

// http://localhost:8000/api
// https://project-manhattan.herokuapp.com/api